/* global angular, moment */
/**
 * Created by lari on 04/05/2017.
 */
(function () {
  'use strict';
  angular.module('vcclient')
    .component('companyedit', {
      restrict: 'E',
      bindings: {
        companydata: '<',
        parentsave: '&'
      },
      templateUrl: 'vcclient/companyedit-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log',
        function ($log) {
          let vm = this;
          vm.save = save;
          
          vm.$onInit = function () {
            vm.lastcompanydata = angular.copy(vm.companydata);
          };
          
          function save() {
            if (!angular.equals(vm.companydata, vm.lastcompanydata)) {
              vm.lastcompanydata = angular.copy(vm.companydata);
              $log.debug('debug: comapnyedit parentsave() called');
              vm.parentsave();
            }
          }
              
          
        }] // controller
    }); // component

// klammerfriedhof
}());